module.exports = __webpack_public_path__ + "static/7fdbea7634894677b7274755a4fec0422891253f943ecc4a86c39a9a69c3150b-2cb68267e737fed81808ecd07a79589a.png";